import styled from '@emotion/styled'
import { Input } from 'components'

export const CustomTextField = styled(Input)({
  '& .MuiOutlinedInput-root': {
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: 'inherit',
    },
  },
})

export const mainBox = {
  height: '60%',
  width: '45vw',
  minWidth: '460px',
  overflowY: 'auto',
}

export const smallScreenNameTextField = {
  width: '100%',
}

export const regularScreenNameTextField = {
  width: '90%',
}

export const parametersBox = {
  width: '100%',
}

export const brBox = {
  height: '2px',
}

export const mainGrid = {
  overflowY: 'auto',
  height: '460px',
}
